if (typeof boostPFSThemeConfig != "undefined")
    var boostPFSFilterConfig = {
        general: {
            limit: boostPFSConfig.custom.products_per_page,
            loadProductFirst: !1,
            numberFilterTree: 2,
            showPlaceholderProductList: !0,
        },
        selector: { breadcrumb: ".breadcrumb", otpTopCartCount: ".cart-count" },
    };
(function () {
    (BoostPFS.inject(this),
        (ProductGridItem.prototype.compileTemplate = function (data) {
            data || (data = this.data);
            var images = data.images_info,
                soldOut = !data.available,
                onSale = data.compare_at_price_min > data.price_min,
                variantComparePrice = "",
                variantPrice = "";
            if (data.price_min) {
                var onSaleVariant = data.compare_at_price_min > data.price_min;
                onSaleVariant &&
                    ((variantComparePrice = parseFloat(data.compare_at_price_min)),
                        (variantPrice = parseFloat(data.price_min)),
                        (onSale = !0));
            } else {
                var onSaleVariant = data.variants.filter(function (e) {
                    return parseFloat(e.compare_at_price) > parseFloat(e.price);
                });
                typeof onSaleVariant[0] != "undefined" &&
                    ((variantComparePrice = parseFloat(
                        onSaleVariant[0].compare_at_price,
                    )),
                        (variantPrice = parseFloat(onSaleVariant[0].price)),
                        (onSale = !0));
            }
            var priceVaries = data.price_min != data.price_max,
                firstVariant = data.variants[0];
            if (
                Utils.getParam("variant") !== null &&
                Utils.getParam("variant") != ""
            ) {
                var paramVariant = data.variants.filter(function (e) {
                    return e.id == Utils.getParam("variant");
                });
                typeof paramVariant[0] != "undefined" &&
                    (firstVariant = paramVariant[0]);
            } else
                for (var i = 0; i < data.variants.length; i++)
                    if (data.variants[i].available) {
                        firstVariant = data.variants[i];
                        break;
                    }
            var itemHtml = boostPFSTemplate.productGridItemHtml,
                gridItemWidthClass = "",
                imageSize = "600x600",
                width = "",
                height = "";
            switch (boostPFSConfig.custom.products_per_row) {
                case 2:
                    ((gridItemWidthClass = "medium--one-half large--one-half"),
                        (imageSize = "540x600"),
                        (width = 540),
                        (height = 600));
                    break;
                case 3:
                    ((gridItemWidthClass =
                        "small--one-half medium--one-third large--one-third"),
                        (imageSize = "345x550"),
                        (width = 345),
                        (height = 550));
                    break;
                case 4:
                    ((gridItemWidthClass =
                        "small--one-half medium--one-quarter large--one-quarter"),
                        (imageSize = "250x"),
                        (width = 250),
                        (height = 225));
                    break;
                case 5:
                    ((gridItemWidthClass =
                        "small--one-half medium--one-fifth large--one-fifth"),
                        (imageSize = "195x"),
                        (width = 195),
                        (height = 125));
                    break;
            }
            itemHtml = itemHtml.replace(
                /{{gridItemWidthClass}}/g,
                gridItemWidthClass,
            );
            var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
            itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
            var onSaleClass = onSale ? boostPFSTemplate.onSaleClass : "";
            itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);
            var count_tag = !1,
                inventoryAvailable = !1,
                inventoryContinue = !1;
            $(data.variants).each(function (index, element) {
                (element.inventory_quantity > 0 && (inventoryAvailable = !0),
                    element.inventory_policy == "continue" &&
                    element.inventory_quantity <= 0 &&
                    (inventoryContinue = !0));
            });

            var stockGroup = "";
            data.metafields &&
                data.metafields.length &&
                (console.log(data),
                    data.metafields.forEach(function (metafield) {
                        metafield.key == "external_stock_group" &&
                            metafield.value &&
                            metafield.value !== "" &&
                            (stockGroup = metafield.value);
                    }));
            
            var inStockMsg = "AVAILABLE TO ORDER"
            var isDirectStock = !1;

            var directStockGroup = (stockGroup == "Enniskillen" ||
                    stockGroup == "GIE" ||
                    stockGroup == "VIDA");

            if ( ( directStockGroup &&
                    ((inStockMsg = "IN STOCK"), (isDirectStock = !0)),
                    inventoryAvailable == !1 && inventoryContinue == !0)
            ) {
                count_tag = !0;
                var pre_order =
                    '<div class="product-qty"><div class="qty-label flex"><span case="1">AVAILABLE TO ORDER</span></div>';
                itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, pre_order);
            } else {
                count_tag = !0;    
                console.log({
                    data: data,
                    stockGroup: stockGroup,
                    directStockGroup: directStockGroup,
                    inventoryAvailable: inventoryAvailable,
                });

                var pre_order =
                    '<div class="product-qty"><div class="qty-label flex"><span case="2">' +
                    inStockMsg +
                    "</span></div>";
                itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, pre_order);
            }
            if (count_tag == !1)
                if (data.available == !1) {
                    var itemSoldOutLabelHtml = soldOut
                        ? boostPFSTemplate.soldOutLabelHtml
                        : "";
                    itemHtml = itemHtml.replace(
                        /{{itemSoldOutLabel}}/g,
                        '<div class="product-qty"><div class="qty-label flex"><span>OUT Of STOCK</span></div>',
                    );
                } else
                    ($(data.variants).each(function (index, element) {
                        element.inventory_quantity > 0 &&
                            element.inventory_quantity <= 5 &&
                            isDirectStock
                            ? (itemHtml = itemHtml.replace(
                                /{{itemSoldOutLabel}}/g,
                                '<div class="product-qty"><div class="qty-label flex dark-label"><span>ONLY ' +
                                element.inventory_quantity +
                                " LEFT IN STOCK</span></div>",
                            ))
                            : (itemHtml = itemHtml.replace(
                                /{{itemSoldOutLabel}}/g,
                                '<div class="product-qty"><div class="qty-label flex"><span case="3">' +
                                inStockMsg +
                                "</span></div>",
                            ));
                    }),
                        data.inventory_quantity > 0
                            ? (itemHtml = itemHtml.replace(
                                /{{itemSoldOutLabel}}/g,
                                '<div class="product-qty"><div class="qty-label flex"><span case="4">' +
                                inStockMsg +
                                "</span></div>",
                            ))
                            : (itemHtml = itemHtml.replace(
                                /{{itemSoldOutLabel}}/g,
                                '<div class="product-qty"><div class="qty-label flex"><span case="5">AVAILABLE TO ORDER</span></div>',
                            )));
            var itemThumbUrl =
                images.length > 0
                    ? Utils.optimizeImage(images[0].src, imageSize)
                    : boostPFSConfig.general.no_image_url;
            itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
            var itemPriceHtml = '<span class="product-price medium--left 456">';
            if (
                (onSale
                    ? (itemPriceHtml +=
                        '<span class="visually-hidden">' +
                        boostPFSConfig.label.sale_price +
                        "</span>")
                    : (itemPriceHtml +=
                        '<span class="visually-hidden">' +
                        boostPFSConfig.label.regular_price +
                        "</span>"),
                    typeof onSaleVariant[0] != "undefined"
                        ? (itemPriceHtml += buildPriceHtml(variantPrice))
                        : (itemPriceHtml += buildPriceHtml(data.price_min)),
                    onSale &&
                    boostPFSConfig.custom.show_compare_at_price &&
                    ((itemPriceHtml +=
                        ' <small class="compare-price"><s><span class="visually-hidden">' +
                        boostPFSConfig.label.regular_price +
                        "</span>"),
                        typeof onSaleVariant[0] != "undefined"
                            ? (itemPriceHtml += buildPriceHtml(variantComparePrice))
                            : (itemPriceHtml += buildPriceHtml(data.compare_at_price_min)),
                        (itemPriceHtml += "</s></small>")),
                    (itemPriceHtml += "</span>"),
                    onSale && boostPFSConfig.custom.product_show_saved_amount)
            ) {
                var class1 = boostPFSConfig.custom.show_compare_at_price
                    ? " medium--right "
                    : "",
                    class2 = boostPFSConfig.custom.product_reviews_enable
                        ? " has-reviews"
                        : "",
                    savePrice = data.compare_at_price_min - data.price_min;
                (typeof onSaleVariant[0] != "undefined" &&
                    (savePrice = variantComparePrice - variantPrice),
                    (savePrice = Utils.formatMoney(savePrice, Globals.moneyFormat, !0)),
                    (itemPriceHtml +=
                        '<span class="badge badge--sale"><span class="badge-label">'));
                var final_price = Math.round(
                    parseFloat(
                        ((data.compare_at_price_min - data.price_min) /
                            data.compare_at_price_min) *
                        100,
                    ),
                );
                (typeof onSaleVariant[0] != "undefined" &&
                    (final_price = Math.round(
                        parseFloat(
                            ((variantComparePrice - variantPrice) / variantComparePrice) *
                            100,
                        ),
                    )),
                    (itemPriceHtml += boostPFSConfig.label.save_price.replace(
                        /{{ saved_amount }}/g,
                        "-" + final_price + "%&nbsp;OFF",
                    )),
                    (itemPriceHtml += "</span></span>"));
            } else
                data.price_max > data.price_min &&
                    ((itemPriceHtml +=
                        ' - <small class="compare-price 13212"><span class="visually-hidden">' +
                        boostPFSConfig.label.regular_price +
                        "</span>"),
                        (itemPriceHtml += buildPriceHtml(data.price_max)),
                        (itemPriceHtml += "</small>"));
            var itemPriceHtml_zero = "";
            data.price_min == 0
                ? ((itemPriceHtml_zero +=
                    '<span class="product-price medium--left 123" style="opacity:0;"><span class="visually-hidden">Regular price</span><small aria-hidden="true"><lomoney>00.00</lomoney></small><span class="visually-hidden"><lomoney>00.00</lomoney></span></span>'),
                    (itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml_zero)))
                : (itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml));
            var count_bundle_tag = !1,
                count_special_tag = !1;
            if (
                ($(data.tags).each(function (index, element) {
                    if (element == "Bundle Deal") {
                        count_bundle_tag = !0;
                        var bundle_tag =
                            '<span class="badge badge--bundle-offer"><span class="badge-label">BUNDLE DEAL</span></span>';
                        itemHtml = itemHtml.replace(
                            /{{itembundleofferLabel}}/g,
                            bundle_tag,
                        );
                    } else itemHtml = itemHtml.replace(/{{itembundleofferLabel}}/g, "");
                    if (element == "special-price") {
                        count_special_tag = !0;
                        var special_tag = '<span class="badge badge-special-price"></span>';
                        itemHtml = itemHtml.replace(/{{itemspecialLabel}}/g, special_tag);
                    }
                }),
                    (itemHtml = itemHtml.replace(/{{itemspecialLabel}}/g, "")),
                    typeof Integration == "undefined" ||
                    !Integration.hascompileTemplate("reviews"))
            ) {
                var itemReviewHtml = boostPFSConfig.custom.product_reviews_enable
                    ? '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span><br>'
                    : "";
                itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewHtml);
            }
            var aspect_ratio = null,
                itemImgHtml = "";
            if (images.length > 0) {
                aspect_ratio = images[0].width / images[0].height;
                var max_width = width,
                    max_height = height;
                (aspect_ratio < 1
                    ? ((max_width = height * aspect_ratio),
                        images[0].height < height
                            ? ((max_height = images[0].height), (max_width = images[0].width))
                            : (max_height = height))
                    : ((max_height = width / aspect_ratio),
                        images[0].width < width
                            ? ((max_height = images[0].height), (max_width = images[0].width))
                            : (max_width = width)),
                    (itemImgHtml +=
                        '<div class="lazyload__image-wrapper no-js" style="max-width:' +
                        max_width +
                        'px"><div><img class="no-js" loading="lazy" src="' +
                        Utils.getFeaturedImage(images, "580x") +
                        '"  "alt="{{itemTitle}}"/></div></div><noscript><img src="' +
                        Utils.getFeaturedImage(images, "580x") +
                        '"srcset="' +
                        Utils.getFeaturedImage(images, "580x") +
                        " 1x, " +
                        Utils.getFeaturedImage(images, "580@2x") +
                        ' 2x" alt="{{itemTitle}}" style="opacity:1;"/></noscript>'));
            } else
                itemImgHtml +=
                    '<div><img src="' + boostPFSConfig.general.no_image_url + '"/></div>';
            if (images.length > 1) {
                aspect_ratio = images[1].width / images[1].height;
                var max_width = width,
                    max_height = height;
                (aspect_ratio < 1
                    ? ((max_width = height * aspect_ratio),
                        images[1].height < height
                            ? ((max_height = images[1].height), (max_width = images[1].width))
                            : (max_height = height))
                    : ((max_height = width / aspect_ratio),
                        images[1].width < width
                            ? ((max_height = images[1].height), (max_width = images[1].width))
                            : (max_width = width)),
                    (itemImgHtml +=
                        '<div class="collection-focus-image" style="max-width:' +
                        max_width +
                        'px" ><img loading="lazy" width="580" class="collection-focus-image__img" src="' +
                        Utils.getFeaturedImage([images[1]], "580x") +
                        '"  "alt="{{itemTitle}}"/></div>'));
            }
            ((itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml)),
                (itemHtml = itemHtml.replace(/{{itemId}}/g, data.id)));
            var productTitle = data.title;
            (data.metafields &&
                data.metafields.length &&
                data.metafields.forEach(function (metafield) {
                    metafield.key == "short_title" &&
                        metafield.value &&
                        metafield.value !== "" &&
                        (productTitle = metafield.value);
                }),
                (itemHtml = itemHtml.replace(/{{itemTitle}}/g, productTitle)));
            var variants_price = data.price_min,
                variants_id = "";
            $(data.variants).each(function (index, element) {
                if (element.price == data.price_min) {
                    var variants_price2 = element.price,
                        variants_id2 = element.id;
                    itemHtml = itemHtml.replace(
                        /{{itemUrl}}/g,
                        Utils.buildProductItemUrlWithVariant(data) +
                        "?variant=" +
                        variants_id2,
                    );
                } else
                    itemHtml = itemHtml.replace(
                        /{{itemUrl}}/g,
                        Utils.buildProductItemUrlWithVariant(data),
                    );
            });
            var count_collection = !1;
            if (
                ($(data.collections).each(function (index, element) {
                    if (
                        element.handle == "colourtrend-paint" ||
                        element.handle == "contemporary-collection" ||
                        element.handle == "historic-collection" ||
                        element.handle == "weather-collection"
                    ) {
                        count_collection = !0;
                        var collection_btn = "hide-button";
                        itemHtml = itemHtml.replace(
                            /{{itemcollectionbtn}}/g,
                            collection_btn,
                        );
                        var enquiry_btn =
                            '<div class="boost-pfs-addtocart-wrapper"><a href="' +
                            Utils.buildProductItemUrlWithVariant(data) +
                            '" class="boost-pfs-addtocart-btn enquiry-btn"><span class="boost-pfs-addtocart-btn-text">ENQUIRE NOW</span></span></a></a></div>';
                        itemHtml = itemHtml.replace(/{{itemenquirybtn}}/g, enquiry_btn);
                    } else if (data.price_min == 0) {
                        count_collection = !0;
                        var collection_btn = "hide-button";
                        itemHtml = itemHtml.replace(
                            /{{itemcollectionbtn}}/g,
                            collection_btn,
                        );
                        var enquiry_btn =
                            '<div class="boost-pfs-addtocart-wrapper"><a href="' +
                            Utils.buildProductItemUrlWithVariant(data) +
                            '" class="boost-pfs-addtocart-btn enquiry-btn"><span class="boost-pfs-addtocart-btn-text">ENQUIRE NOW</span></span></a></a></div>';
                        itemHtml = itemHtml.replace(/{{itemenquirybtn}}/g, enquiry_btn);
                    }
                }),
                    count_collection == !1 &&
                    ((itemHtml = itemHtml.replace(/{{itemcollectionbtn}}/g, "")),
                        (itemHtml = itemHtml.replace(/{{itemenquirybtn}}/g, ""))),
                    data.images[1])
            )
                itemHtml = itemHtml.replace(/{{itemnoimage}}/g, "");
            else {
                var no_image = "no-image";
                itemHtml = itemHtml.replace(/{{itemnoimage}}/g, no_image);
            }
            return itemHtml;
        }),
        (ProductListItem.prototype.compileTemplate = function (data) {
            data || (data = this.data);
            var images = data.images_info,
                soldOut = !data.available,
                onSale = data.compare_at_price_min > data.price_min,
                priceVaries = data.price_min != data.price_max,
                firstVariant = data.variants[0];
            if (
                Utils.getParam("variant") !== null &&
                Utils.getParam("variant") != ""
            ) {
                var paramVariant = data.variants.filter(function (e) {
                    return e.id == Utils.getParam("variant");
                });
                typeof paramVariant[0] != "undefined" &&
                    (firstVariant = paramVariant[0]);
            } else
                for (var i = 0; i < data.variants.length; i++)
                    if (data.variants[i].available) {
                        firstVariant = data.variants[i];
                        break;
                    }
            var itemHtml = boostPFSTemplate.productListItemHtml,
                soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
            itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
            var onSaleClass = onSale ? boostPFSTemplate.onSaleClass : "";
            itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);
            var itemSoldOutLabelHtml = soldOut
                ? boostPFSTemplate.soldOutLabelHtml
                : "";
            itemHtml = itemHtml.replace(
                /{{itemSoldOutLabel}}/g,
                itemSoldOutLabelHtml,
            );
            var itemThumbUrl =
                images.length > 0
                    ? Utils.optimizeImage(images[0].src, "600x600")
                    : boostPFSConfig.general.no_image_url;
            itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
            var itemPriceHtml = '<span class="medium--left">';
            if (
                (onSale
                    ? (itemPriceHtml +=
                        '<span class="visually-hidden">' +
                        boostPFSConfig.label.sale_price +
                        "</span>")
                    : (itemPriceHtml +=
                        '<span class="visually-hidden">' +
                        boostPFSConfig.label.regular_price +
                        "</span>"),
                    (itemPriceHtml += buildPriceHtml(data.price_min)),
                    onSale &&
                    boostPFSConfig.custom.show_compare_at_price &&
                    ((itemPriceHtml +=
                        ' <small><s><span class="visually-hidden">' +
                        boostPFSConfig.label.regular_price +
                        "</span>"),
                        (itemPriceHtml += buildPriceHtml(data.compare_at_price_min)),
                        (itemPriceHtml += "</s></small>")),
                    (itemPriceHtml += "</span>"),
                    onSale && boostPFSConfig.custom.product_show_saved_amount)
            ) {
                var class1 = boostPFSConfig.custom.show_compare_at_price
                    ? " medium--right "
                    : "",
                    class2 = boostPFSConfig.custom.product_reviews_enable
                        ? " has-reviews"
                        : "",
                    savePrice = data.compare_at_price_min - data.price_min;
                ((savePrice = Utils.formatMoney(savePrice, Globals.moneyFormat, !0)),
                    (itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">'),
                    (itemPriceHtml += boostPFSConfig.label.save_price.replace(
                        /{{ saved_amount }}/g,
                        savePrice,
                    )),
                    (itemPriceHtml += "</span>"));
            }
            itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
            var itemDescription = jQ("<p>" + data.body_html + "</p>").text();
            return (
                (itemDescription =
                    itemDescription.split(" ").length > 40
                        ? itemDescription.split(" ").splice(0, 40).join(" ") + "..."
                        : itemDescription.split(" ").splice(0, 40).join(" ")),
                (itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription)),
                (itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title)),
                (itemHtml = itemHtml.replace(
                    /{{itemUrl}}/g,
                    Utils.buildProductItemUrlWithVariant(data),
                )),
                itemHtml
            );
        }));
    function buildPriceHtml(price) {
        var customPrice = Utils.formatMoney(price);
        Globals.moneyFormat.indexOf("money") > -1 ||
            Globals.moneyFormat.indexOf(".") > -1 ||
            (boostPFSConfig.custom.superscript_decimals &&
                (Globals.moneyFormat.indexOf("{{amount}}") !== -1 ||
                    Globals.moneyFormat.indexOf("{{ amount }}") !== -1
                    ? (customPrice = customPrice.replace(".", "<sup>") + "</sup>")
                    : (Globals.moneyFormat.indexOf("{{amount_with_comma_separator}}") !==
                        -1 ||
                        Globals.moneyFormat.indexOf(
                            "{{ amount_with_comma_separator }}",
                        ) !== -1) &&
                    (customPrice = customPrice.replace(",", "<sup>") + "</sup>")));
        var html = '<small aria-hidden="true">' + customPrice + "</small>";
        return (
            (html +=
                '<span class="visually-hidden">' +
                Utils.formatMoney(price) +
                "</span>"),
            html
        );
    }
    ((ProductPaginationDefault.prototype.compileTemplate = function (
        totalProduct,
    ) {
        totalProduct || (totalProduct = this.totalProduct);
        var currentPage = parseInt(Globals.queryParams.page),
            totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
        if (totalPage > 1) {
            var paginationHtml = boostPFSTemplate.paginateHtml,
                previousHtml =
                    currentPage > 1
                        ? boostPFSTemplate.previousActiveHtml
                        : boostPFSTemplate.previousDisabledHtml;
            ((previousHtml = previousHtml.replace(
                /{{itemUrl}}/g,
                Utils.buildToolbarLink("page", currentPage, currentPage - 1),
            )),
                (paginationHtml = paginationHtml.replace(
                    /{{previous}}/g,
                    previousHtml,
                )));
            var nextHtml =
                currentPage < totalPage
                    ? boostPFSTemplate.nextActiveHtml
                    : boostPFSTemplate.nextDisabledHtml;
            ((nextHtml = nextHtml.replace(
                /{{itemUrl}}/g,
                Utils.buildToolbarLink("page", currentPage, currentPage + 1),
            )),
                (paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml)));
            for (
                var beforeCurrentPageArr = [], iBefore = currentPage - 1;
                iBefore > currentPage - 3 && iBefore > 0;
                iBefore--
            )
                beforeCurrentPageArr.unshift(iBefore);
            (currentPage - 4 > 0 && beforeCurrentPageArr.unshift("..."),
                currentPage - 4 >= 0 && beforeCurrentPageArr.unshift(1),
                beforeCurrentPageArr.push(currentPage));
            for (
                var afterCurrentPageArr = [], iAfter = currentPage + 1;
                iAfter < currentPage + 3 && iAfter <= totalPage;
                iAfter++
            )
                afterCurrentPageArr.push(iAfter);
            (currentPage + 3 < totalPage && afterCurrentPageArr.push("..."),
                currentPage + 3 <= totalPage && afterCurrentPageArr.push(totalPage));
            for (
                var pageItemsHtml = "",
                pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr),
                iPage = 0;
                iPage < pageArr.length;
                iPage++
            )
                (pageArr[iPage] == "..."
                    ? (pageItemsHtml += boostPFSTemplate.pageItemRemainHtml)
                    : (pageItemsHtml +=
                        pageArr[iPage] == currentPage
                            ? boostPFSTemplate.pageItemSelectedHtml
                            : boostPFSTemplate.pageItemHtml),
                    (pageItemsHtml = pageItemsHtml.replace(
                        /{{itemTitle}}/g,
                        pageArr[iPage],
                    )),
                    (pageItemsHtml = pageItemsHtml.replace(
                        /{{itemUrl}}/g,
                        Utils.buildToolbarLink("page", currentPage, pageArr[iPage]),
                    )));
            return (
                (paginationHtml = paginationHtml.replace(
                    /{{pageItems}}/g,
                    pageItemsHtml,
                )),
                paginationHtml
            );
        }
        return "";
    }),
        (ProductSorting.prototype.compileTemplate = function () {
            var html = "";
            if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
                var sortingArr = Utils.getSortingList();
                if (sortingArr) {
                    var sortingItemsHtml = "";
                    for (var k in sortingArr)
                        sortingItemsHtml +=
                            '<option value="' + k + '">' + sortingArr[k] + "</option>";
                    html = boostPFSTemplate.sortingHtml.replace(
                        /{{sortingItems}}/g,
                        sortingItemsHtml,
                    );
                }
            }
            return html;
        }),
        (ProductDisplayType.prototype.compileTemplate = function () {
            var itemHtml = boostPFSTemplate.displayTypeHtml;
            return (
                (itemHtml = itemHtml.replace(
                    /{{gridUrl}}/g,
                    Utils.buildToolbarLink("display", "list", "grid"),
                )),
                (itemHtml = itemHtml.replace(
                    /{{listUrl}}/g,
                    Utils.buildToolbarLink("display", "grid", "list"),
                )),
                (itemHtml = itemHtml.replace(/{{gridView}}/g, Labels.gridView)),
                (itemHtml = itemHtml.replace(/{{listView}}/g, Labels.listView)),
                itemHtml
            );
        }),
        (Breadcrumb.prototype.compileTemplate = function (colData) {
            colData || (colData = this.collectionData);
            var breadcrumbHtml = "";
            if (boostPFSTemplate.hasOwnProperty("breadcrumbHtml")) {
                breadcrumbHtml = boostPFSTemplate.breadcrumbHtml;
                var colInfo = colData.collection,
                    currentCollectionHtml = "";
                (Array.isArray(boostPFSConfig.general.current_tags) &&
                    boostPFSConfig.general.current_tags.length > 0
                    ? ((currentCollectionHtml +=
                        ' <a href="/collections/' +
                        colInfo.handle +
                        '">' +
                        colInfo.title +
                        "</a>"),
                        (currentCollectionHtml +=
                            ' <span class="divider" aria-hidden="true">&rsaquo;</span>'),
                        (currentCollectionHtml +=
                            " <span>" + current_tags.join(" + ") + "</span>"))
                    : (currentCollectionHtml += " <span>" + colInfo.title + "</span>"),
                    (breadcrumbHtml = breadcrumbHtml.replace(
                        /{{currentCollection}}/g,
                        currentCollectionHtml,
                    )));
            }
            return breadcrumbHtml;
        }),
        (ProductList.prototype.afterRender = function (data) { }),
        (Filter.prototype.afterRender = function (data) {
            (data || (data = this.data),
                jQ(document).ready(function () {
                    if (typeof theme != "undefined" && theme.hasOwnProperty("Sections")) {
                        var sections = new theme.Sections();
                        sections.register("collection-template", theme.Collection);
                    }
                }));
            var totalProduct = data.total_product + "<span>Products</span>";
            (data.total_product == 1 &&
                (totalProduct = data.total_product + "<span>Products</span>"),
                jQ(".boost-pfs-filter-total-product").html(totalProduct),
                window.SPR && (SPR.initDomEls(), SPR.loadBadges()));
        }));
})();
